import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

interface IssueChipProps {
  label: string;
  selected: boolean;
  mode: 'single' | 'multi';
  onSelect: () => void;
  className?: string;
}

export function IssueChip({
  label,
  selected,
  mode,
  onSelect,
  className,
}: IssueChipProps) {
  return (
    <button
      onClick={onSelect}
      className={cn(
        "px-6 py-3 rounded-full border-2 transition-all duration-200",
        "hover:shadow-md",
        mode === 'single'
          ? selected
            ? "bg-gradient-to-r from-[#196644] to-[#0D382A] border-[#196644] text-white"
            : "bg-white border-gray-200 text-gray-700 hover:border-[#196644]"
          : selected
          ? "bg-[#A7F3A1]/20 border-[#196644] text-[#0D382A]"
          : "bg-white border-gray-200 text-gray-700 hover:border-[#196644]",
        className
      )}
    >
      <div className="flex items-center gap-2">
        {selected && mode === 'single' && (
          <Check className="w-4 h-4" />
        )}
        {selected && mode === 'multi' && (
          <Check className="w-4 h-4" />
        )}
        <span>{label}</span>
      </div>
    </button>
  );
}

